module.exports = __webpack_public_path__ + "static/23-9c65a9c03de03f4be2db6871af00a755.jpg";